// imports
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// local imports
import { RootState, uiActions } from '../store';

const HUC12_BANNER = {
  id: 'huc12-zoom-warning',
  message: 'Zoom in to interact with HUC12s',
  severity: 'warning',
};

const ZOOM_THRESHOLD = 7.5;

export default function useHuc12Banner() {
  const dispatch = useDispatch();
  const zoom = useSelector((s: RootState) => s.map.viewState.zoom);
  const awdNoData = useSelector((s: RootState) => s.ui.awdNoData);
  const addedRef = useRef(false);

  useEffect(() => {
    // Remove banner when no data is available
    if (awdNoData && addedRef.current) {
      dispatch(uiActions.removeBannerMessage(HUC12_BANNER.id));
      addedRef.current = false;
      return;
    }

    // Do not add banner when no data is available
    if (awdNoData) return;

    // Add banner on app load (if zoom < ZOOM_THRESHOLD)
    if (!addedRef.current && zoom < ZOOM_THRESHOLD) {
      dispatch(uiActions.addBannerMessage(HUC12_BANNER));
      addedRef.current = true;
    }

    // Remove banner when zoom reaches ZOOM_THRESHOLD or higher
    if (zoom >= ZOOM_THRESHOLD && addedRef.current) {
      dispatch(uiActions.removeBannerMessage(HUC12_BANNER.id));
      addedRef.current = false;
    }

    // keep effect driven only by zoom, awdNoData, and dispatch
  }, [zoom, awdNoData, dispatch]);

  // ensure cleanup if parent that used the hook unmounts
  useEffect(() => {
    return () => {
      if (addedRef.current) {
        dispatch(uiActions.removeBannerMessage(HUC12_BANNER.id));
        addedRef.current = false;
      }
    };
  }, [dispatch]);
}
